// extracted by mini-css-extract-plugin
export default {"Vcard":"Transaction_Vcard__8ZAAW","VAcctTxt":"Transaction_VAcctTxt__Mpvoq","VFundTxt":"Transaction_VFundTxt__NHpcC","VBank":"Transaction_VBank__DugiQ"};